<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1792MTP/tc-custom/9781429987981.jpg?1732051009059" alt="This image is the cover for the book It's Hard Not to Hate You"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">It's Hard Not to Hate You
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>From the author of</i> THIN IS THE NEW HAPPY <i>comes a hilarious new memoir about embracing your Inner Hater. In the midst of a health and career crisis, Valerie uncorks years of pent up rage, and discovers you don't have to be happy to be happy. You don't have to love everyone else to like yourself. And that your Bitchy Twin might just be your funniest, most valuable and honest ally.<br/><br/></i>"</b>The hate in you has got to come out<b>."</b><br/><br/>After being advised to reduce stress by her doctor, humorist Valerie Frankel realized the biggest source of pressure in her life was maintaining an unflappable easing-going persona. After years of glossing over the negative, Frankel goes on a mission of emotional honesty, vowing to let herself feel and express all the toxic emotions she'd long suppressed or denied: jealousy, rage, greed, envy, impatience, regret. <br/><br/>Frankel reveals her personal History of Hate, from mean girls in junior high, selfish boyfriends in her twenties and old professional rivals. Hate stomps through her current life, too, with snobby neighbors, rude cell phone talkers, scary doctors and helicopter moms. Regarding her husband, she asks, "How Do I Hate You? Let Me Count the Ways." (FYI: There are three.) <br/><br/>By the end of her authentic emotional experience, Frankel concludes that toxic emotions are actually <i>good</i> for you. The positive thinkers, aka, <i>The Secret</i> crowd, have it backwards. Trying to ward off negativity was what'd been causing Frankel's career stagnation, as well as her health and personal problems. With the guidance of celebrity friends like Joan Rivers and psychic Mary T. Browne, Frankel now uses anger, jealousy and impatience as tools to be a better, balanced and deeper person. <br/><br/>IT'S HARD NOT TO HATE YOU sends the message that there are no wrong emotions, only wrong ways of dealing with them.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Valerie Frankel
      </h2>
      
      <p class="authorDescription body article"><P>VALERIE FRANKEL is the author of <I>THIN IS THE NEW HAPPY</I> and such chick lit favorites as <I>THE ACCIDENTAL VIRGIN</I>, <I>THE GIRLFRIEND CURSE</I> and <I>HEX AND THE SINGLE GIRL</I>. The former articles editor at Mademoiselle, Valerie has contributed to the New York Times, O, Glamour, Allure, Self, Good Housekeeping, among many other publications.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bc9f0ff6